import React from "react";
import Design from "./Design";

function Tabel() {
  return (
    <>
      <div className="flex flex-wrap items-center bg-white shadow-lg mx-1">
        <Design size={20} chairs={8} chairSize={5} />
        <Design size={20} chairs={8} chairSize={5} />
        <Design size={20} chairs={8} chairSize={5} />
        <Design size={20} chairs={8} chairSize={5} />
        <Design size={20} chairs={8} chairSize={5} />
        <Design size={20} chairs={8} chairSize={5} />
      </div>
    </>
  );
}

export default Tabel;
